import { Injectable } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';

import { Observable } from 'rxjs/Observable';
import { Subscriber } from 'rxjs/Subscriber';
export { Subscription } from 'rxjs/Subscription';
import 'rxjs/add/operator/filter';
import 'rxjs/add/operator/map';

@Injectable()
export class NavigationService {
    private onNavigatedSubscribers: Subscriber<ActivatedRoute>[] = [];

    constructor(private router: Router, private route: ActivatedRoute) {
        this.router.events
            .filter(event => event instanceof NavigationEnd)
            .map(() => this.route)
            .map(route => {
                while (route.firstChild) route = route.firstChild;
                return route;
            })
            .subscribe(route => {
                this.currentRoute = route;
                this.notifyNavigationSubscribers();
            });

        this.onNavigated = new Observable<ActivatedRoute>((subscriber: Subscriber<ActivatedRoute>) => {
            this.onNavigatedSubscribers.push(subscriber);
        });
    }

    private notifyNavigationSubscribers() {
        for (let i = 0; i < this.onNavigatedSubscribers.length;) {
            let subscriber = this.onNavigatedSubscribers[i];
            if (subscriber.closed) {
                this.onNavigatedSubscribers.splice(i, 1);
            } else {
                i++;
                subscriber.next(this.currentRoute);
            }
        }
    }

    onNavigated: Observable<ActivatedRoute>;
    currentRoute: ActivatedRoute;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./TypeScript/core/navigation/navigation.service.ts